
import { normalizeApiError } from "../../../utils/normalizeApiError";
import axiosInstance from "../../axiosInstance";

export const getProjectMembers = async (
  orgUuid: string
) => {
  try {
    const { data } = await axiosInstance.get(
      `organisation/${orgUuid}/get-all-pmo-manager-and-pmo-user`
    );
    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};

